var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3337 53.0833H4.66699C3.71033 53.0833 2.91699 52.2899 2.91699 51.3333C2.91699 50.3766 3.71033 49.5833 4.66699 49.5833H51.3337C52.2903 49.5833 53.0837 50.3766 53.0837 51.3333C53.0837 52.2899 52.2903 53.0833 51.3337 53.0833Z",
    fill: "#25BBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M49.0005 23.2868V51.3335H6.88379L7.00045 23.2635C7.00045 21.8401 7.65379 20.4869 8.79712 19.6003L25.1305 6.90692C26.8105 5.57692 29.1905 5.57692 30.8705 6.90692L33.9971 9.33354L44.3338 17.3602L47.2038 19.6003C48.3471 20.4869 49.0005 21.8402 49.0005 23.2868Z",
    fill: "#25BBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3327 39.6665H25.666C23.7293 39.6665 22.166 41.2298 22.166 43.1665V51.3332H33.8327V43.1665C33.8327 41.2298 32.2694 39.6665 30.3327 39.6665Z",
    fill: "#25BBBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.167 32.0834H17.5003C16.217 32.0834 15.167 31.0334 15.167 29.7501V26.2501C15.167 24.9667 16.217 23.9167 17.5003 23.9167H22.167C23.4503 23.9167 24.5003 24.9667 24.5003 26.2501V29.7501C24.5003 31.0334 23.4503 32.0834 22.167 32.0834Z",
    fill: "#25BBBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 32.0834H33.8333C32.55 32.0834 31.5 31.0334 31.5 29.7501V26.2501C31.5 24.9667 32.55 23.9167 33.8333 23.9167H38.5C39.7833 23.9167 40.8333 24.9667 40.8333 26.2501V29.7501C40.8333 31.0334 39.7833 32.0834 38.5 32.0834Z",
    fill: "#25BBBB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3337 17.3599L33.9971 9.33325H41.9537C43.2371 9.33325 44.2871 10.3599 44.2871 11.6432L44.3337 17.3599Z",
    fill: "#25BBBB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.b540a9afc138fa6003bc0a8e6487cdd8.svg";
export { ForwardRef as ReactComponent };